import { indexItems } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精选专题</h2>
          <p className="text-sm text-foreground-600">七大专区，为你找到最适合今夜心情的电影</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={item.id}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector(item.href)?.scrollIntoView({ behavior: "smooth" });
              }}
              className={`group block p-5 md:p-6 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer ${
                i === 0 ? "sm:col-span-2 lg:col-span-2 lg:row-span-2" : ""
              }`}
            >
              <div className="flex items-start gap-4">
                <span className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${
                  i === 0 ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                }`}>
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <div className={i === 0 ? "flex-1" : ""}>
                  <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-1">{item.title}</h3>
                  <p className="text-xs text-primary-500 font-medium mb-2">{item.subtitle}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}